import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.concat.js";
import VueCropper from 'vue-cropperjs';
import { useCropperMethods } from '~/core/composables';
import OverlayLoading from '~/core/components/OverlayLoading/OverlayLoading.vue';
import EditorTemplate from './EditorTemplate.vue';
import ActionBtn from './ActionBtn.vue';
import { IMAGE_EDITOR_TOOLBAR_HEIGHT } from './constants';
var MIN_CROP_BOX_SIZE_MULTIPLIER = 0.3;
var VUE_CROPPER_PADDING_OFFSET = 10;
export default defineComponent({
  name: 'ImageCropper',
  components: {
    EditorTemplate: EditorTemplate,
    ActionBtn: ActionBtn,
    OverlayLoading: OverlayLoading,
    VueCropper: VueCropper
  },
  props: {
    src: {
      type: String,
      required: true
    }
  },
  emits: ['cropped'],
  setup: function setup(props, _ref) {
    var emit = _ref.emit;
    var cropper = ref(null);
    var isReady = ref(false);
    var isCropping = ref(false);
    var _useNuxtApp = useNuxtApp(),
      $vuetify = _useNuxtApp.$vuetify,
      $device = _useNuxtApp.$device;
    var _useCropperMethods = useCropperMethods(cropper),
      getCroppedFile = _useCropperMethods.getCroppedFile,
      reset = _useCropperMethods.reset,
      rotateWithReset = _useCropperMethods.rotateWithReset,
      zoom = _useCropperMethods.zoom;
    var containerStyle = computed(function () {
      return {
        minHeight: '100%',
        width: '100%',
        maxWidth: '100%',
        position: 'relative',
        zIndex: '0',
        maxHeight: "".concat($vuetify.breakpoint.height - $vuetify.application.top - IMAGE_EDITOR_TOOLBAR_HEIGHT - VUE_CROPPER_PADDING_OFFSET, "px")
      };
    });
    var cropBoxSize = computed(function () {
      var minDimension = Math.min($vuetify.breakpoint.height, $vuetify.breakpoint.width);
      return minDimension * MIN_CROP_BOX_SIZE_MULTIPLIER;
    });
    var cropperActions = computed(function () {
      var constantActions = [{
        icon: 'ui-icon-undo',
        text: 'Сбросить',
        handler: function handler() {
          return reset();
        }
      }, {
        icon: 'ui-icon-clockwise',
        text: 'Поворот',
        handler: function handler() {
          return rotateWithReset(-90);
        }
      }];
      if ($device.isDesktop) {
        return [{
          icon: 'ui-icon-magnifying-glass-plus',
          text: 'Увеличить',
          handler: function handler() {
            return zoom(0.1);
          }
        }, {
          icon: 'ui-icon-magnifying-glass-minus',
          text: 'Уменьшить',
          handler: function handler() {
            return zoom(-0.1);
          }
        }].concat(constantActions);
      }
      return constantActions;
    });
    function cropImage() {
      return _cropImage.apply(this, arguments);
    }
    function _cropImage() {
      _cropImage = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              isCropping.value = true;
              _context.t0 = emit;
              _context.next = 4;
              return getCroppedFile();
            case 4:
              _context.t1 = _context.sent;
              (0, _context.t0)('cropped', _context.t1);
              isCropping.value = false;
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return _cropImage.apply(this, arguments);
    }
    function handleReady() {
      isReady.value = true;
    }
    return {
      cropBoxSize: cropBoxSize,
      cropper: cropper,
      isReady: isReady,
      isCropping: isCropping,
      containerStyle: containerStyle,
      cropImage: cropImage,
      cropperActions: cropperActions,
      handleReady: handleReady
    };
  }
});